namespace GeniuzPOS.PosShift {
    export interface LookupTaxInvoiceforVatRefundRow {
        DocNo?: string;
        ShopId?: string;
        RefDocNo?: string;
        PropertyName?: string;
    }

    export namespace LookupTaxInvoiceforVatRefundRow {
        export const idProperty = 'DocNo';
        export const nameProperty = 'DocNo';
        export const localTextPrefix = 'PosShift.LookupTaxInvoiceforVatRefund';
        export const lookupKey = 'PosShift.LookupTaxInvoiceforVatRefund';

        export function getLookup(): Q.Lookup<LookupTaxInvoiceforVatRefundRow> {
            return Q.getLookup<LookupTaxInvoiceforVatRefundRow>('PosShift.LookupTaxInvoiceforVatRefund');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            DocNo = "DocNo",
            ShopId = "ShopId",
            RefDocNo = "RefDocNo",
            PropertyName = "PropertyName"
        }
    }
}
